import React from "react";

interface TipBoxProps {
  result: any;
}

const tips = [
  "Risk 1% per day and aim for 2-3% weekly growth.",
  "Protect your capital first. Passing is a byproduct.",
  "Consistency beats speed in funded challenges.",
  "Grow steady, avoid big drawdowns to stay funded.",
  "Margin safety is just as important as risk management."
];

const deepDrawdownTips = [
  "⚠️ Deep in drawdown? It's better to stop trading and reset your plan.",
  "⚠️ When in deep drawdown, forcing recovery often leads to bigger losses.",
  "⚠️ Protect your mental capital as much as your financial capital."
];

export const TipBox: React.FC<TipBoxProps> = ({ result }) => {
  if (!result) return null;

  const isDeepDrawdown = result.currentDrawdownPercent >= 6;

  const displayedTips = isDeepDrawdown ? deepDrawdownTips : tips;

  const randomTip = displayedTips[Math.floor(Math.random() * displayedTips.length)];

  return (
    <div className="bg-[#2a2a2a] rounded-2xl shadow-md p-6">
      <h2 className="text-xl font-bold text-neutral-100 mb-4 flex items-center gap-2">
        <span>💡</span> Pro Tip
      </h2>
      <p className="text-lg text-yellow-400">{randomTip}</p>
    </div>
  );
};

export default TipBox;
